// extracted by mini-css-extract-plugin
export default {"underlay":"PopoverOverlay_underlay__3ymQT","popover":"PopoverOverlay_popover__qCP-t","arrow":"PopoverOverlay_arrow__BvWO9"};